export const ORBIT_PLANNER_CAMERA_DESCRIPTION = {
    name: 'orbit-planner-camera-description',
    is_enabled: true,
    initiate_tabs: [
        {
            tag: 'Cameras',
            setup: (tab, camera) => {
                const container = tab.get_container('🎥 ' + camera.name, { is_collapsed: true });
                container.watch(camera, 'offset');
                container.watch(camera, 'target');
                const rotation = container.container('rotation');
                rotation.watch(camera, 'yaw_radians', { name: 'yaw' });
                rotation.watch(camera, 'pitch_radians', { name: 'pitch' });
                const projection = container.container('Projection');
                projection.watch(camera.projection, 'aspect_ratio', { is_readonly: true });
                projection.watch(camera.projection, 'near', { is_readonly: true });
                projection.watch(camera.projection, 'far', { is_readonly: true });
                const fov = projection.container('Field of View', { is_collapsed: true });
                fov.watch(camera.projection, 'field_of_view');
                fov.watch(camera.projection, 'horizontal_fov', { is_readonly: true });
                fov.watch(camera.projection, 'vertical_fov', { is_readonly: true });
                fov.watch(camera.projection, 'field_of_view_direction', { is_readonly: true });
            }
        }
    ]
};
//# sourceMappingURL=OrbitPlannerCameraDescription.js.map